import { Steps } from 'antd'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
const { Step } = Steps

interface ArticleStepsPorps {
  currentNum: number
  length: number
  style?: React.CSSProperties
}
export const ArticleSteps = (props: ArticleStepsPorps) => {
  const { currentNum, length, style } = props
  const [current, setcurrent] = useState(currentNum)
  const [itemList, setItemList] = useState([])
  useEffect(() => {
    let arr = []
    for (let i = 0; i < length; i++) {
      arr.push(i)
    }
    setItemList(arr)
  }, [length])
  return (
    <>
      <Steps current={current} initial={0} type="default" size="small" style={style}>
        {itemList?.map((item, index) => (
          <Step key={index} icon={current > index && <StepIcon>{index + 1}</StepIcon>} />
        ))}
      </Steps>
    </>
  )
}
const StepIcon = styled.div`
  width: 24px;
  height: 24px;
  margin: 0 8px 0 0;
  font-size: 12px;
  line-height: 22px;
  text-align: center;
  margin-right: 0;
  background: #4238c9;
  color: #fff;
  border: 1px solid #4238c9;
  border-radius: 4px;
`
